import React, { useEffect, useState } from "react";
import { getPublicSettings } from "../lib/settings";
import { getCookieConsent } from "./CookieConsent";

let scriptLoaded = false;
const loadScript = (client) => {
  if (scriptLoaded || document.querySelector(`script[src*="adsbygoogle.js"]`)) { scriptLoaded = true; return; }
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`;
  s.crossOrigin = "anonymous";
  document.head.appendChild(s);
  scriptLoaded = true;
};

// Renders a Google AdSense ad unit ONLY when AdSense is enabled and configured by the admin.
export const AdSlot = ({ className = "" }) => {
  const [cfg, setCfg] = useState(null);
  const [consent, setConsent] = useState(getCookieConsent());

  useEffect(() => { getPublicSettings().then(setCfg); }, []);
  useEffect(() => {
    const onChange = () => setConsent(getCookieConsent());
    window.addEventListener("rj-consent-changed", onChange);
    return () => window.removeEventListener("rj-consent-changed", onChange);
  }, []);

  const enabled = cfg?.adsense_enabled && cfg?.adsense_client && cfg?.adsense_slot && consent === "accepted";

  useEffect(() => {
    if (enabled) {
      loadScript(cfg.adsense_client);
      const id = setTimeout(() => {
        try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) { /* noop */ }
      }, 300);
      return () => clearTimeout(id);
    }
  }, [enabled, cfg]);

  if (!enabled) return null;

  return (
    <div className={`w-full overflow-hidden ${className}`} data-testid="adsense-slot">
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={cfg.adsense_client}
        data-ad-slot={cfg.adsense_slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};
